/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

export enum FollowUpActionResponseDtoSourceType {
  QUESTIONNAIRE_ANSWER = "QUESTIONNAIRE_ANSWER",
  COMPLIANCE_TASK_INSTANCE = "COMPLIANCE_TASK_INSTANCE",
  OUT_OF_RANGE_INCIDENT = "OUT_OF_RANGE_INCIDENT",
  EVENT_RECORD = "EVENT_RECORD",
  FIRE_EXTINGUISHER_CHECK_ITEM = "FIRE_EXTINGUISHER_CHECK_ITEM",
  EMERGENCY_LIGHT_CHECK_ITEM = "EMERGENCY_LIGHT_CHECK_ITEM",
  LOG_ENTRY = "LOG_ENTRY",
}
